module.exports = __webpack_public_path__ + "static/img/PA@2x.91ccf4ed.jpg";